import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "31",
  fill: "none",
  viewBox: "0 0 31 31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.833 4.573a1.125 1.125 0 0 1 1.125-1.125h3.75a1.125 1.125 0 0 1 1.125 1.125v3.75a1.125 1.125 0 1 1-2.25 0V7.288l-6.705 6.705a1.125 1.125 0 0 1-1.59 0l-3.705-3.704-6.33 6.33a1.125 1.125 0 1 1-1.59-1.59l7.125-7.126a1.125 1.125 0 0 1 1.59 0l3.705 3.706 5.91-5.91h-1.035a1.125 1.125 0 0 1-1.125-1.126M6.458 21.45a1.125 1.125 0 0 1 1.125 1.124v3.75a1.125 1.125 0 0 1-2.25 0v-3.75a1.125 1.125 0 0 1 1.125-1.125m7.125-3.376a1.125 1.125 0 1 0-2.25 0v8.25a1.125 1.125 0 0 0 2.25 0zm4.875 1.875a1.125 1.125 0 0 1 1.125 1.125v5.25a1.125 1.125 0 0 1-2.25 0v-5.25a1.125 1.125 0 0 1 1.125-1.125m7.125-4.875a1.125 1.125 0 1 0-2.25 0v11.25a1.125 1.125 0 0 0 2.25 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }